module.exports = __webpack_public_path__ + "img/PointsMenu.7134dd09.svg";